import { Typography, TextField, Button, Box, Grid, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useState, useEffect } from "react";

const EditOrderModel = ({
  previousTotalCost,
  onClose,
  onUpdate,
  currentLoadType = "",
}) => {
  const [newCost, setNewCost] = useState(previousTotalCost);
  const [newLoadType, setNewLoadType] = useState(currentLoadType);

  useEffect(() => {
    setNewCost(previousTotalCost);
  }, [previousTotalCost]);
  useEffect(() => {
    setNewLoadType(currentLoadType || "");
  }, [currentLoadType]);

  const costChanged =
    newCost !== "" && !isNaN(Number(newCost)) && Number(newCost) >= 0 &&
    Number(newCost) !== Number(previousTotalCost);
  const loadTypeChanged = (newLoadType || "") !== (currentLoadType || "");
  const isDisabled = !(costChanged || loadTypeChanged);

  return (
    <Box p={3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="subtitle1">
            Previous Total Cost: ₹{previousTotalCost}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <TextField
            label="New Total Cost"
            type="number"
            fullWidth
            size="small"
            value={newCost}
            onChange={(e) => setNewCost(e.target.value)}
          />
        </Grid>

        <Grid item xs={12}>
          <FormControl fullWidth size="small">
            <InputLabel id="edit-loadType-label">Load Type</InputLabel>
            <Select
              labelId="edit-loadType-label"
              id="edit-loadType"
              label="Load Type"
              value={newLoadType}
              onChange={(e) => setNewLoadType(e.target.value)}
            >
              <MenuItem value="">None</MenuItem>
              <MenuItem value="Part Load">Part Load</MenuItem>
              <MenuItem value="Full Load">Full Load</MenuItem>
              <MenuItem value="Inter City">Inter City</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button onClick={onClose} variant="outlined" size="small">
              Close
            </Button>
            <Button
              onClick={()=>onUpdate(newCost, newLoadType)}
              variant="contained"
              size="small"
              disabled={isDisabled}
            >
              Update
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EditOrderModel;
